var map = {
	"./Bin.png": 13,
	"./Collections-Active.png": 42,
	"./Collections.png": 87,
	"./Home-Active.png": 43,
	"./Home.png": 88,
	"./Interest-Active.png": 44,
	"./Interest.png": 89,
	"./Mood-Active.png": 45,
	"./Mood.png": 90,
	"./Profile-Active.png": 46,
	"./Profile.png": 91,
	"./Spread-Active.png": 47,
	"./Spread.png": 92,
	"./Star.png": 23,
	"./Star1.png": 18,
	"./Trackers-Active.png": 48,
	"./Trackers.png": 93
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86;